export const hasAddressData = (address) => {
  return (
    address?.city ||
    address?.countryNormalized ||
    address?.formatted ||
    address?.search
  )
}
